export default __webpack_public_path__ + "static/media/cert-it-hkgcsmeaa.757943de.jpg";